import { TableComponent } from "../../components/base-requirements/TableComponent.tsx";

export default function BaseRequirementsPage() {
  return (
    <div className="w-full h-full p-14">
      <TableComponent />
    </div>
  );
}
